import React, { Component } from "react";
import { History } from "history";

import routing from "../../routing";
import { languages, genders, displayNames, schoolTypes, motherTongues } from "../../../common/parameters";

import AccountView from "./accountView";
import messages from "./messages";
import {IControllerProps, IState } from "./interfaces";
import { ReactFacebookLoginInfo } from "react-facebook-login/dist/facebook-login-render-props";
import { TokenResponse } from "@react-oauth/google";
import { getAppFromHistory, getAppPrefix } from "../../../common/app";

class Account extends Component<IControllerProps, IState> {
    constructor(props: IControllerProps) {
        super(props);
        const app = getAppFromHistory(props.history);
        if (!props.user.profiled && !props.user.isStudent) {
            props.history.push(getAppPrefix(app) + "/" + routing.signupProfile);
            return;
        }
        this.state = {
            newPassword: false,
            changePassword: false,
            changeTextModal: false,
            changeSelectModal: false,
            changeNumberModal: false,
            changeRadioModal: false,
            deleteAccount: false,
            fbInProgress: false,
            modalOpen: false,
            changeCheckboxModal: false,
            changingLabel: "",
            changingValue: "",
            changingName: "",
            modalType: "",
            options: [],
            glInProgress: false,
            cropping: false,
            setImageToggle: false,
            verificationSuccess: false,
            imageLoaded: false,
            img: "",
        };
    }
    changeTextValue = (name: string, value: string) => {
        const {
            intl: { formatMessage },
        } = this.props;
        this.setState({
            changeTextModal: true,
            changingName: name,
            changingValue: value,
            changingLabel: formatMessage(messages[name]),
        });
    };
    changeNumberValue = (name: string, value: number) => {
        const {
            intl: { formatMessage },
        } = this.props;
        this.setState({
            changeNumberModal: true,
            changingName: name,
            changingValue: value,
            changingLabel: formatMessage(messages[name]),
        });
    };
    changeSelectValue = (name: string, value: string) => {
        let options: IState["options"] = [];
        const {
            intl: { formatMessage },
        } = this.props;
        if (name === "displayName") options = displayNames(formatMessage);
        if (name === "language") options = languages(formatMessage);
        if (name === "gender") options = genders(formatMessage);
        if (name === "motherTongue") options = motherTongues;
        this.setState({
            changeSelectModal: true,
            changingName: name,
            changingValue: value,
            changingLabel: formatMessage(messages[name]),
            options,
        });
    };
    changeRadioValue = (name: string, value: number) => {
        let options: IState["options"] = [];
        const {
            intl: { formatMessage },
        } = this.props;
        if (name === "gender") options = genders(formatMessage);
        this.setState({
            changeRadioModal: true,
            changingName: name,
            changingValue: value,
            changingLabel: formatMessage(messages[name]),
            options,
        });
    };
    changeCheckboxValue = (name: string, value: string[]) => {
        let options: IState["options"] = [];
        const {
            intl: { formatMessage },
        } = this.props;
        if (name === "school_types") options = schoolTypes(formatMessage);
        this.setState({
            changeCheckboxModal: true,
            changingName: name,
            changingValue: [...value],
            changingLabel: formatMessage(messages[name]),
            options,
        });
    };
    removeFacebook = () => {
        this.setState({ fbInProgress: true });
        this.props.post("remove-facebook", {}, res => {
            const { data } = res;
            if (data.success) {
                this.props.editUser(data.user);
            }
            this.setState({ fbInProgress: false });
        });
    };
    facebookLoginStarted = () => {
        this.setState({ fbInProgress: true });
    };
    facebookConnect = (res: ReactFacebookLoginInfo) => {
        if (!res.accessToken) {
            return this.setState({ fbInProgress: false, modalOpen: true, modalType: "fb connection error" });
        }
        this.props.post("facebook-connect", { accessToken: res.accessToken }, res => {
            const { data } = res;
            this.setState({ fbInProgress: false });
            if (data.success) {
                this.props.editUser(data.user);
            } else if (data.facebookUsed) {
                this.setState({ modalOpen: true, modalType: "fb already connected" });
            } else {
                this.setState({ modalOpen: true, modalType: "fb connection error" });
            }
        });
    };

    removeGoogle = () => {
        this.setState({ glInProgress: true });
        this.props.post("remove-google", {}, res => {
            const { data } = res;
            if (data.success) {
                this.props.editUser(data.user);
            }
            this.setState({ glInProgress: false });
        });
    };

    googleConnectSuccess = (res: Omit<TokenResponse, "error" | "error_description" | "error_uri">) => {
        this.setState({ glInProgress: true });
        this.props.post("google-connect", { accessToken: res.access_token }, res => {
            const { data } = res;
            this.setState({ glInProgress: false });
            if (data.success) {
                this.props.editUser(data.user);
            } else if (data.googleUsed) {
                this.setState({ modalOpen: true, modalType: "gl already connected" });
            } else {
                this.setState({ modalOpen: true, modalType: "gl connection error" });
            }
        });
    };

    googleConnectFailure = () => {
        return this.setState({ modalOpen: true, modalType: "gl connection error" });
    };

    croppingStarted = () => {
        this.setState({ cropping: true });
    };

    cropDone = () => {
        this.setState({ setImageToggle: true });
    };

    setImage = (img: string) => {
        this.props.post("update-profile-picture", { img }, () => {
            this.setState({ img, cropping: false, setImageToggle: false, imageLoaded: false });
            this.props.user.profilePicture = img;
            this.props.editUser({ ...this.props.user });
        });
    };
    resendVerification = () => {
        this.props.post("resend-verification", {}, () => {
            this.setState({ verificationSuccess: true });
        });
    };
    closeModal = () => this.setState({ modalOpen: false });
    onImageLoaded = () => this.setState({ imageLoaded: true });
    setCropping = (cropping: boolean) => this.setState({ cropping });
    unloadImage = () => this.setState({ imageLoaded: false });

    closeChangeTextModal = () => this.setState({ changeTextModal: false });
    closeChangeNumberModal = () => this.setState({ changeNumberModal: false });
    closeChangeSelectModal = () => this.setState({ changeSelectModal: false });
    closeChangeRadioModal = () => this.setState({ changeRadioModal: false });
    closeChangeCheckboxModal = () => this.setState({ changeCheckboxModal: false });
    setDeleteAccount = (deleteAccount?: React.MouseEvent<HTMLDivElement>) => this.setState({ deleteAccount: !!deleteAccount });
    setChangePassword = (changePassword?: React.MouseEvent<HTMLDivElement>) => this.setState({ changePassword: !!changePassword });
    setNewPassword = (newPassword?: React.MouseEvent<HTMLDivElement>) => this.setState({ newPassword: !!newPassword });
    render() {
        return <AccountView {...this.props} {...this.state} {...this} setState={this.setState} />;
    }
}

export default Account;
